var map = {
	"./4DUK/1.jpeg": 860,
	"./UKoblong/1.jpeg": 624,
	"./adhesivePads/1.jpeg": 886,
	"./nutsAndBolts/1.jpeg": 211,
	"./screwsWithCaps/1.jpeg": 597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 805;